/**
 * Supabase client configuration for the platform
 * Used for shorts metadata and likes storage
 */
import { createClient } from '@supabase/supabase-js';

// Use the actual Supabase credentials for the project
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://dlmcxxzohervnbixauhs.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRsbWN4eHpvaGVydm5iaXhhdWhzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUxNzcwNzEsImV4cCI6MjA2MDc1MzA3MX0.UIQ7Wqo3R9aTYHYQHTFsHWGdhFFKLHjhEShlz2J2J-Q';

// Create the Supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Helper to check if Supabase is properly configured
export const isSupabaseConfigured = () => {
  return SUPABASE_URL !== 'YOUR_SUPABASE_URL' && SUPABASE_ANON_KEY !== 'YOUR_SUPABASE_ANON_KEY';
};